export default "__VITE_ASSET__56a946b9__"